export enum CommodityType {
  Electricity = 'Electricity',
  Gas = 'Gas',
  Unknown = 'Unknown',
}
